/* eslint-disable no-unused-vars */
import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import './style.css'; // Importez le fichier CSS
import { Link } from 'react-router-dom';
import { cardData } from '../../Data/ArticleData';
import Footer from '../../Components/Footer';
import ScrollToTop from '../../Components/scrollup'
const categories = ['All categories', 'web developement', 'Design'];

export default function Blog() {
  const [focusedCardIndex, setFocusedCardIndex] = React.useState(null);
  const [selectedCategory, setSelectedCategory] = React.useState('All categories');

  const handleFocus = (index) => {
    setFocusedCardIndex(index);
  };

  const handleBlur = () => {
    setFocusedCardIndex(null);
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const filteredCardData = selectedCategory === 'All categories'
    ? cardData
    : cardData.filter((card) => card.tag === selectedCategory);

  return (
    <div className='blog'>
        <ScrollToTop/>
      <div className='blogHead'>
    
        <h1>
          Blog
        </h1>
        <Typography>actualités et nouveautés</Typography>
     
        </div>
        <div className='blogBody'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          width: '95%',
          justifyContent: 'space-between',
          alignItems: { xs: 'start', md: 'center' },
          gap: 4,
          overflow: 'auto',
          marginTop:'20px',
          marginLeft:{ xs: '0px', sm:'200px',md: '200px',lg:'200px'},
        }}
      >
        <Box className="chip-group">
          {categories.map((category) => (
            <Chip
              key={category}
              label={category}
              onClick={() => handleCategoryClick(category)}
              size="medium"
              className={`chip ${selectedCategory === category ? 'selected' : ''}`}
            />
          ))}
        </Box>
      </Box>
 
      
        {filteredCardData.map((card, index) => (
          <a href={`/articles/${card.title}`} className='cardLink'>
          <div key={index} >
            <Card
              variant="outlined"
              onFocus={() => handleFocus(index)}
              onBlur={handleBlur}
              tabIndex={0}
              className='card'

            >
              <CardMedia
                component="img"
                alt={card.title}
                src={require(`../../images/${card.img}.jpg`)}
                className="card-media"
              />
              <CardContent className="syled-card-content">
                <Typography gutterBottom variant="caption" component="div" color='warning'>
                  {card.tag}
                </Typography>
                <h4>
                  {card.title}
                </h4>
                <Typography variant="body2" color="text.secondary" gutterBottom className="styled-typography" dangerouslySetInnerHTML={{ __html: card.description }}/>
                 
              </CardContent>
              <Box className="author">
                <Box className="author-info" >
                  <AvatarGroup max={3} >
                    {card.authors.map((author, index) => (
                      <Avatar key={index} alt={author.name} src={require(`../../images/${author.name}.jpg`)} sx={{ width: 24, height: 24 }} />
                    ))}
                  </AvatarGroup>
                  <h6>
                    {card.authors.map((author) => author.name).join(', ')}
                  </h6>
                </Box>
                <Typography variant="caption">{card.date}</Typography>
              </Box>
            </Card>
          </div>
          </a>
        ))}
      </div>
    </div>
  );
}
